<div class="my-4">
  <p-stepper [value]="activeIndex" [linear]="true" aria-hidden="true">
    <p-step-list>
      <p-step [value]="1" [pt]="{ header: { tabIndex: -1 }}">Get Started</p-step>
      <p-step [value]="2" [pt]="{ header: { tabIndex: -1 }}">Your Information</p-step>
      <p-step [value]="3" [pt]="{ header: { tabIndex: -1 }}">Select Account</p-step>
    </p-step-list>
  </p-stepper>
</div>

@if (false) {
  <p-message severity="error">
    A user has already been registered with this preferred business email, please enter a new email
  </p-message>
}

@if (!isLoading) {
  @if (activeIndex === 1) {
    <app-get-started (goNext)="goNext()" />
  }
  @if (activeIndex === 2) {
    <app-user-info
      [value]="userData"
      [userInfoForm]="userInfoForm"
      (goNext)="handleUserInfoComplete($event)"
    />
  }
  @if (activeIndex === 3) {
    <app-select-account
      [userInfoForm]="userInfoForm"
      [tenants]="tenants"
      [providerType]="providerType"
      [providerTypes]="providerTypes"
      [providers]="selectedProviders"
      [selectedTenants]="selectedAccounts"
      (goBack)="goBack()"
      (addProvider)="addProvider($event)"
      (deleteProviders)="removeProviders($event)"
      (addAccount)="addTenant($event)"
      (deleteAccount)="removeTenant($event)"
      (changeProviderType)="handleProviderTypeChange($event)"
      [emailServerError]="emailError"
      (save)="handleSubmit()"
      (recaptchaTokenChanged)="recaptchaToken = $event"
    />
  }
  @if (activeIndex === 4 && saveSuccess) {
    <div>
      <h1 id="confirmation-heading" class="sr-only" tabindex="-1" aria-hidden="false">Confirmation</h1>
      <p>
        Thank you for registering for the Carelon provider portal. You will receive an email once
        your account has been approved by the Carelon Portal Support team to complete your account
        set-up. If you need immediate assistance, please contact the portal support department at
        <a [attr.href]="portalSupportLink" target="_blank" class="mr-2 no-underline">Portal Support.</a>
      </p>
      <p class="pt-4">
        Please note that you will be automatically enrolled in multi-factor authentication and will need
        to enter a one-time verification code to sign in once your account is set up. You can receive the
        code either at the email address that you used during registration, or on your device after you
        enroll it via an authenticator app, such as Microsoft Authenticator.
      </p>
    </div>
  }
}

@if (isLoading) {
  <div class="flex items-center justify-center">
    <p-progressSpinner />
  </div>
}

<p-toast position="bottom-left" />
